import { Box} from "@mui/material";
import { useNavigate } from "react-router-dom";

function Header(): JSX.Element {
    const navigate = useNavigate();

    return (
        <>
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{position: "relative"}}
        >
            <Box
                marginTop={3}
                marginBottom={3}
                onClick={() => navigate("/")}
            >
                <img src="poolmelogo.png" width={"100px"}/>
            </Box>
        </Box>
        </>
      );
};
export default Header;
